/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Tessera Backend API
 * Tessera backend application with Bearer token authentication and multi-tenant support
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  InvalidateOptions,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { BodyType, ErrorType } from '../api-instance';
import { apiInstance } from '../api-instance';
import type {
  GetHanaViewTargetDagParams,
  GetHanaViewTargetDagPathParameters,
  GetHanaViewTargetProcedureSqlParams,
  GetHanaViewTargetProcedureSqlPathParameters,
  GetHanaViewTargetXmlParams,
  GetHanaViewTargetXmlPathParameters,
  ListHanaViewTargetsParams,
  ListHanaViewTargetsPathParameters,
  ListHanaViewTargetVersionsParams,
  ListHanaViewTargetVersionsPathParameters,
  TLCalculationViewDag,
  TLHanaViewTargetResponse,
  TLHanaViewTargetXmlUpdateRequest,
  TLHanaViewXmlResponse,
  TLHTTPValidationError,
  TLPaginatedResponseHanaViewTargetResponse,
  TLPaginatedResponseHanaViewVersionResponse,
  TLProcedureSqlResponse,
  UpdateHanaViewTargetXmlPathParameters,
} from './tessera-backend-api.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List Hana View Targets
 */
export const listHanaViewTargets = (
  { viewId }: ListHanaViewTargetsPathParameters,
  params?: ListHanaViewTargetsParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLPaginatedResponseHanaViewTargetResponse>(
    { url: `/hana-views/${viewId}/targets`, method: 'GET', params, signal },
    options,
  );
};

export const getListHanaViewTargetsQueryKey = (
  { viewId }: ListHanaViewTargetsPathParameters,
  params?: ListHanaViewTargetsParams,
) => {
  return ['hana-views', viewId, 'targets', ...(params ? [params] : [])] as const;
};

export const getListHanaViewTargetsQueryOptions = <
  TData = Awaited<ReturnType<typeof listHanaViewTargets>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { viewId }: ListHanaViewTargetsPathParameters,
  params?: ListHanaViewTargetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHanaViewTargets>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListHanaViewTargetsQueryKey({ viewId }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listHanaViewTargets>>> = ({ signal }) =>
    listHanaViewTargets({ viewId }, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: viewId !== null && viewId !== undefined, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listHanaViewTargets>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListHanaViewTargetsQueryResult = NonNullable<Awaited<ReturnType<typeof listHanaViewTargets>>>;
export type ListHanaViewTargetsQueryError = ErrorType<TLHTTPValidationError>;

export function useListHanaViewTargets<
  TData = Awaited<ReturnType<typeof listHanaViewTargets>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ListHanaViewTargetsPathParameters,
  params: undefined | ListHanaViewTargetsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHanaViewTargets>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHanaViewTargets>>,
          TError,
          Awaited<ReturnType<typeof listHanaViewTargets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListHanaViewTargets<
  TData = Awaited<ReturnType<typeof listHanaViewTargets>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ListHanaViewTargetsPathParameters,
  params?: ListHanaViewTargetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHanaViewTargets>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHanaViewTargets>>,
          TError,
          Awaited<ReturnType<typeof listHanaViewTargets>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListHanaViewTargets<
  TData = Awaited<ReturnType<typeof listHanaViewTargets>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ListHanaViewTargetsPathParameters,
  params?: ListHanaViewTargetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHanaViewTargets>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Hana View Targets
 */

export function useListHanaViewTargets<
  TData = Awaited<ReturnType<typeof listHanaViewTargets>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { viewId }: ListHanaViewTargetsPathParameters,
  params?: ListHanaViewTargetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHanaViewTargets>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListHanaViewTargetsQueryOptions({ viewId }, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Hana View Targets
 */
export const prefetchListHanaViewTargetsQuery = async <
  TData = Awaited<ReturnType<typeof listHanaViewTargets>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { viewId }: ListHanaViewTargetsPathParameters,
  params?: ListHanaViewTargetsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHanaViewTargets>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListHanaViewTargetsQueryOptions({ viewId }, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary List Hana View Targets
 */
export const invalidateListHanaViewTargets = async (
  queryClient: QueryClient,
  { viewId }: ListHanaViewTargetsPathParameters,
  params?: ListHanaViewTargetsParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getListHanaViewTargetsQueryKey({ viewId }, params) }, options);

  return queryClient;
};

/**
 * @summary Get Hana View Target Dag
 */
export const getHanaViewTargetDag = (
  { viewId, targetId }: GetHanaViewTargetDagPathParameters,
  params?: GetHanaViewTargetDagParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLCalculationViewDag>(
    { url: `/hana-views/${viewId}/targets/${targetId}/dag`, method: 'GET', params, signal },
    options,
  );
};

export const getGetHanaViewTargetDagQueryKey = (
  { viewId, targetId }: GetHanaViewTargetDagPathParameters,
  params?: GetHanaViewTargetDagParams,
) => {
  return ['hana-views', viewId, 'targets', targetId, 'dag', ...(params ? [params] : [])] as const;
};

export const getGetHanaViewTargetDagQueryOptions = <
  TData = Awaited<ReturnType<typeof getHanaViewTargetDag>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { viewId, targetId }: GetHanaViewTargetDagPathParameters,
  params?: GetHanaViewTargetDagParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetDag>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHanaViewTargetDagQueryKey({ viewId, targetId }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHanaViewTargetDag>>> = ({ signal }) =>
    getHanaViewTargetDag({ viewId, targetId }, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: viewId !== null && viewId !== undefined && targetId !== null && targetId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetDag>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetHanaViewTargetDagQueryResult = NonNullable<Awaited<ReturnType<typeof getHanaViewTargetDag>>>;
export type GetHanaViewTargetDagQueryError = ErrorType<TLHTTPValidationError>;

export function useGetHanaViewTargetDag<
  TData = Awaited<ReturnType<typeof getHanaViewTargetDag>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetHanaViewTargetDagPathParameters,
  params: undefined | GetHanaViewTargetDagParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetDag>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHanaViewTargetDag>>,
          TError,
          Awaited<ReturnType<typeof getHanaViewTargetDag>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHanaViewTargetDag<
  TData = Awaited<ReturnType<typeof getHanaViewTargetDag>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetHanaViewTargetDagPathParameters,
  params?: GetHanaViewTargetDagParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetDag>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHanaViewTargetDag>>,
          TError,
          Awaited<ReturnType<typeof getHanaViewTargetDag>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHanaViewTargetDag<
  TData = Awaited<ReturnType<typeof getHanaViewTargetDag>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetHanaViewTargetDagPathParameters,
  params?: GetHanaViewTargetDagParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetDag>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Hana View Target Dag
 */

export function useGetHanaViewTargetDag<
  TData = Awaited<ReturnType<typeof getHanaViewTargetDag>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { viewId, targetId }: GetHanaViewTargetDagPathParameters,
  params?: GetHanaViewTargetDagParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetDag>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHanaViewTargetDagQueryOptions({ viewId, targetId }, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Hana View Target Dag
 */
export const prefetchGetHanaViewTargetDagQuery = async <
  TData = Awaited<ReturnType<typeof getHanaViewTargetDag>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { viewId, targetId }: GetHanaViewTargetDagPathParameters,
  params?: GetHanaViewTargetDagParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetDag>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetHanaViewTargetDagQueryOptions({ viewId, targetId }, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Hana View Target Dag
 */
export const invalidateGetHanaViewTargetDag = async (
  queryClient: QueryClient,
  { viewId, targetId }: GetHanaViewTargetDagPathParameters,
  params?: GetHanaViewTargetDagParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getGetHanaViewTargetDagQueryKey({ viewId, targetId }, params) },
    options,
  );

  return queryClient;
};

/**
 * @summary Get Hana View Target Procedure Sql
 */
export const getHanaViewTargetProcedureSql = (
  { viewId, targetId }: GetHanaViewTargetProcedureSqlPathParameters,
  params?: GetHanaViewTargetProcedureSqlParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLProcedureSqlResponse>(
    { url: `/hana-views/${viewId}/targets/${targetId}/procedure-sql`, method: 'GET', params, signal },
    options,
  );
};

export const getGetHanaViewTargetProcedureSqlQueryKey = (
  { viewId, targetId }: GetHanaViewTargetProcedureSqlPathParameters,
  params?: GetHanaViewTargetProcedureSqlParams,
) => {
  return ['hana-views', viewId, 'targets', targetId, 'procedure-sql', ...(params ? [params] : [])] as const;
};

export const getGetHanaViewTargetProcedureSqlQueryOptions = <
  TData = Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { viewId, targetId }: GetHanaViewTargetProcedureSqlPathParameters,
  params?: GetHanaViewTargetProcedureSqlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHanaViewTargetProcedureSqlQueryKey({ viewId, targetId }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>> = ({ signal }) =>
    getHanaViewTargetProcedureSql({ viewId, targetId }, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: viewId !== null && viewId !== undefined && targetId !== null && targetId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetHanaViewTargetProcedureSqlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>
>;
export type GetHanaViewTargetProcedureSqlQueryError = ErrorType<TLHTTPValidationError>;

export function useGetHanaViewTargetProcedureSql<
  TData = Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetHanaViewTargetProcedureSqlPathParameters,
  params: undefined | GetHanaViewTargetProcedureSqlParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>,
          TError,
          Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHanaViewTargetProcedureSql<
  TData = Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetHanaViewTargetProcedureSqlPathParameters,
  params?: GetHanaViewTargetProcedureSqlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>,
          TError,
          Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHanaViewTargetProcedureSql<
  TData = Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetHanaViewTargetProcedureSqlPathParameters,
  params?: GetHanaViewTargetProcedureSqlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Hana View Target Procedure Sql
 */

export function useGetHanaViewTargetProcedureSql<
  TData = Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { viewId, targetId }: GetHanaViewTargetProcedureSqlPathParameters,
  params?: GetHanaViewTargetProcedureSqlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHanaViewTargetProcedureSqlQueryOptions({ viewId, targetId }, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Hana View Target Procedure Sql
 */
export const prefetchGetHanaViewTargetProcedureSqlQuery = async <
  TData = Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { viewId, targetId }: GetHanaViewTargetProcedureSqlPathParameters,
  params?: GetHanaViewTargetProcedureSqlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetProcedureSql>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetHanaViewTargetProcedureSqlQueryOptions({ viewId, targetId }, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Hana View Target Procedure Sql
 */
export const invalidateGetHanaViewTargetProcedureSql = async (
  queryClient: QueryClient,
  { viewId, targetId }: GetHanaViewTargetProcedureSqlPathParameters,
  params?: GetHanaViewTargetProcedureSqlParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getGetHanaViewTargetProcedureSqlQueryKey({ viewId, targetId }, params) },
    options,
  );

  return queryClient;
};

/**
 * @summary List Hana View Target Versions
 */
export const listHanaViewTargetVersions = (
  { viewId, targetId }: ListHanaViewTargetVersionsPathParameters,
  params?: ListHanaViewTargetVersionsParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLPaginatedResponseHanaViewVersionResponse>(
    { url: `/hana-views/${viewId}/targets/${targetId}/versions`, method: 'GET', params, signal },
    options,
  );
};

export const getListHanaViewTargetVersionsQueryKey = (
  { viewId, targetId }: ListHanaViewTargetVersionsPathParameters,
  params?: ListHanaViewTargetVersionsParams,
) => {
  return ['hana-views', viewId, 'targets', targetId, 'versions', ...(params ? [params] : [])] as const;
};

export const getListHanaViewTargetVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listHanaViewTargetVersions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { viewId, targetId }: ListHanaViewTargetVersionsPathParameters,
  params?: ListHanaViewTargetVersionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHanaViewTargetVersions>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListHanaViewTargetVersionsQueryKey({ viewId, targetId }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listHanaViewTargetVersions>>> = ({ signal }) =>
    listHanaViewTargetVersions({ viewId, targetId }, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: viewId !== null && viewId !== undefined && targetId !== null && targetId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listHanaViewTargetVersions>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListHanaViewTargetVersionsQueryResult = NonNullable<Awaited<ReturnType<typeof listHanaViewTargetVersions>>>;
export type ListHanaViewTargetVersionsQueryError = ErrorType<TLHTTPValidationError>;

export function useListHanaViewTargetVersions<
  TData = Awaited<ReturnType<typeof listHanaViewTargetVersions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ListHanaViewTargetVersionsPathParameters,
  params: undefined | ListHanaViewTargetVersionsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHanaViewTargetVersions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHanaViewTargetVersions>>,
          TError,
          Awaited<ReturnType<typeof listHanaViewTargetVersions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListHanaViewTargetVersions<
  TData = Awaited<ReturnType<typeof listHanaViewTargetVersions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ListHanaViewTargetVersionsPathParameters,
  params?: ListHanaViewTargetVersionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHanaViewTargetVersions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listHanaViewTargetVersions>>,
          TError,
          Awaited<ReturnType<typeof listHanaViewTargetVersions>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListHanaViewTargetVersions<
  TData = Awaited<ReturnType<typeof listHanaViewTargetVersions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: ListHanaViewTargetVersionsPathParameters,
  params?: ListHanaViewTargetVersionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHanaViewTargetVersions>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Hana View Target Versions
 */

export function useListHanaViewTargetVersions<
  TData = Awaited<ReturnType<typeof listHanaViewTargetVersions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { viewId, targetId }: ListHanaViewTargetVersionsPathParameters,
  params?: ListHanaViewTargetVersionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHanaViewTargetVersions>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListHanaViewTargetVersionsQueryOptions({ viewId, targetId }, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List Hana View Target Versions
 */
export const prefetchListHanaViewTargetVersionsQuery = async <
  TData = Awaited<ReturnType<typeof listHanaViewTargetVersions>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { viewId, targetId }: ListHanaViewTargetVersionsPathParameters,
  params?: ListHanaViewTargetVersionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listHanaViewTargetVersions>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getListHanaViewTargetVersionsQueryOptions({ viewId, targetId }, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary List Hana View Target Versions
 */
export const invalidateListHanaViewTargetVersions = async (
  queryClient: QueryClient,
  { viewId, targetId }: ListHanaViewTargetVersionsPathParameters,
  params?: ListHanaViewTargetVersionsParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getListHanaViewTargetVersionsQueryKey({ viewId, targetId }, params) },
    options,
  );

  return queryClient;
};

/**
 * @summary Get Hana View Target Xml
 */
export const getHanaViewTargetXml = (
  { viewId, targetId }: GetHanaViewTargetXmlPathParameters,
  params?: GetHanaViewTargetXmlParams,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLHanaViewXmlResponse>(
    { url: `/hana-views/${viewId}/targets/${targetId}/xml`, method: 'GET', params, signal },
    options,
  );
};

export const getGetHanaViewTargetXmlQueryKey = (
  { viewId, targetId }: GetHanaViewTargetXmlPathParameters,
  params?: GetHanaViewTargetXmlParams,
) => {
  return ['hana-views', viewId, 'targets', targetId, 'xml', ...(params ? [params] : [])] as const;
};

export const getGetHanaViewTargetXmlQueryOptions = <
  TData = Awaited<ReturnType<typeof getHanaViewTargetXml>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { viewId, targetId }: GetHanaViewTargetXmlPathParameters,
  params?: GetHanaViewTargetXmlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetXml>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHanaViewTargetXmlQueryKey({ viewId, targetId }, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHanaViewTargetXml>>> = ({ signal }) =>
    getHanaViewTargetXml({ viewId, targetId }, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: viewId !== null && viewId !== undefined && targetId !== null && targetId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetXml>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetHanaViewTargetXmlQueryResult = NonNullable<Awaited<ReturnType<typeof getHanaViewTargetXml>>>;
export type GetHanaViewTargetXmlQueryError = ErrorType<TLHTTPValidationError>;

export function useGetHanaViewTargetXml<
  TData = Awaited<ReturnType<typeof getHanaViewTargetXml>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetHanaViewTargetXmlPathParameters,
  params: undefined | GetHanaViewTargetXmlParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetXml>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHanaViewTargetXml>>,
          TError,
          Awaited<ReturnType<typeof getHanaViewTargetXml>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHanaViewTargetXml<
  TData = Awaited<ReturnType<typeof getHanaViewTargetXml>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetHanaViewTargetXmlPathParameters,
  params?: GetHanaViewTargetXmlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetXml>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHanaViewTargetXml>>,
          TError,
          Awaited<ReturnType<typeof getHanaViewTargetXml>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetHanaViewTargetXml<
  TData = Awaited<ReturnType<typeof getHanaViewTargetXml>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: GetHanaViewTargetXmlPathParameters,
  params?: GetHanaViewTargetXmlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetXml>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Hana View Target Xml
 */

export function useGetHanaViewTargetXml<
  TData = Awaited<ReturnType<typeof getHanaViewTargetXml>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { viewId, targetId }: GetHanaViewTargetXmlPathParameters,
  params?: GetHanaViewTargetXmlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetXml>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetHanaViewTargetXmlQueryOptions({ viewId, targetId }, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Hana View Target Xml
 */
export const prefetchGetHanaViewTargetXmlQuery = async <
  TData = Awaited<ReturnType<typeof getHanaViewTargetXml>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { viewId, targetId }: GetHanaViewTargetXmlPathParameters,
  params?: GetHanaViewTargetXmlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHanaViewTargetXml>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetHanaViewTargetXmlQueryOptions({ viewId, targetId }, params, options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Hana View Target Xml
 */
export const invalidateGetHanaViewTargetXml = async (
  queryClient: QueryClient,
  { viewId, targetId }: GetHanaViewTargetXmlPathParameters,
  params?: GetHanaViewTargetXmlParams,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getGetHanaViewTargetXmlQueryKey({ viewId, targetId }, params) },
    options,
  );

  return queryClient;
};

/**
 * @summary Update Hana View Target Xml
 */
export const updateHanaViewTargetXml = (
  { viewId, targetId }: UpdateHanaViewTargetXmlPathParameters,
  tLHanaViewTargetXmlUpdateRequest: BodyType<TLHanaViewTargetXmlUpdateRequest>,
  options?: SecondParameter<typeof apiInstance>,
  signal?: AbortSignal,
) => {
  return apiInstance<TLHanaViewTargetResponse>(
    {
      url: `/hana-views/${viewId}/targets/${targetId}/xml`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: tLHanaViewTargetXmlUpdateRequest,
      signal,
    },
    options,
  );
};

export const getUpdateHanaViewTargetXmlQueryKey = (
  { viewId, targetId }: UpdateHanaViewTargetXmlPathParameters,
  tLHanaViewTargetXmlUpdateRequest?: BodyType<TLHanaViewTargetXmlUpdateRequest>,
) => {
  return ['PUT', 'hana-views', viewId, 'targets', targetId, 'xml', tLHanaViewTargetXmlUpdateRequest] as const;
};

export const getUpdateHanaViewTargetXmlQueryOptions = <
  TData = Awaited<ReturnType<typeof updateHanaViewTargetXml>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { viewId, targetId }: UpdateHanaViewTargetXmlPathParameters,
  tLHanaViewTargetXmlUpdateRequest: BodyType<TLHanaViewTargetXmlUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateHanaViewTargetXml>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getUpdateHanaViewTargetXmlQueryKey({ viewId, targetId }, tLHanaViewTargetXmlUpdateRequest);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof updateHanaViewTargetXml>>> = ({ signal }) =>
    updateHanaViewTargetXml({ viewId, targetId }, tLHanaViewTargetXmlUpdateRequest, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: viewId !== null && viewId !== undefined && targetId !== null && targetId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof updateHanaViewTargetXml>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type UpdateHanaViewTargetXmlQueryResult = NonNullable<Awaited<ReturnType<typeof updateHanaViewTargetXml>>>;
export type UpdateHanaViewTargetXmlQueryError = ErrorType<TLHTTPValidationError>;

export function useUpdateHanaViewTargetXml<
  TData = Awaited<ReturnType<typeof updateHanaViewTargetXml>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: UpdateHanaViewTargetXmlPathParameters,
  tLHanaViewTargetXmlUpdateRequest: BodyType<TLHanaViewTargetXmlUpdateRequest>,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateHanaViewTargetXml>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateHanaViewTargetXml>>,
          TError,
          Awaited<ReturnType<typeof updateHanaViewTargetXml>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateHanaViewTargetXml<
  TData = Awaited<ReturnType<typeof updateHanaViewTargetXml>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: UpdateHanaViewTargetXmlPathParameters,
  tLHanaViewTargetXmlUpdateRequest: BodyType<TLHanaViewTargetXmlUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateHanaViewTargetXml>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof updateHanaViewTargetXml>>,
          TError,
          Awaited<ReturnType<typeof updateHanaViewTargetXml>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUpdateHanaViewTargetXml<
  TData = Awaited<ReturnType<typeof updateHanaViewTargetXml>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  pathParams: UpdateHanaViewTargetXmlPathParameters,
  tLHanaViewTargetXmlUpdateRequest: BodyType<TLHanaViewTargetXmlUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateHanaViewTargetXml>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Update Hana View Target Xml
 */

export function useUpdateHanaViewTargetXml<
  TData = Awaited<ReturnType<typeof updateHanaViewTargetXml>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  { viewId, targetId }: UpdateHanaViewTargetXmlPathParameters,
  tLHanaViewTargetXmlUpdateRequest: BodyType<TLHanaViewTargetXmlUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateHanaViewTargetXml>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUpdateHanaViewTargetXmlQueryOptions(
    { viewId, targetId },
    tLHanaViewTargetXmlUpdateRequest,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Update Hana View Target Xml
 */
export const prefetchUpdateHanaViewTargetXmlQuery = async <
  TData = Awaited<ReturnType<typeof updateHanaViewTargetXml>>,
  TError = ErrorType<TLHTTPValidationError>,
>(
  queryClient: QueryClient,
  { viewId, targetId }: UpdateHanaViewTargetXmlPathParameters,
  tLHanaViewTargetXmlUpdateRequest: BodyType<TLHanaViewTargetXmlUpdateRequest>,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof updateHanaViewTargetXml>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getUpdateHanaViewTargetXmlQueryOptions(
    { viewId, targetId },
    tLHanaViewTargetXmlUpdateRequest,
    options,
  );

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Update Hana View Target Xml
 */
export const invalidateUpdateHanaViewTargetXml = async (
  queryClient: QueryClient,
  { viewId, targetId }: UpdateHanaViewTargetXmlPathParameters,
  tLHanaViewTargetXmlUpdateRequest: BodyType<TLHanaViewTargetXmlUpdateRequest>,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries(
    { queryKey: getUpdateHanaViewTargetXmlQueryKey({ viewId, targetId }, tLHanaViewTargetXmlUpdateRequest) },
    options,
  );

  return queryClient;
};
